import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GridModule } from "@progress/kendo-angular-grid";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { DirectivesModule } from "../../../core/directives/directives.module";
import { PipesModule } from "../../../shared/_pipes/pipes.module";
import { GestionOrService } from "../../modulos/taller/componentes/gestion-or/gestion-or.service";
import { GestionService } from "../../modulos/taller/componentes/gestion-or/gestion.service";
import { SharedPanelService } from "../shared-panel/shared-panel.service";
import { GenericTableComponent } from "./generic-table.component";
import {PopoverModule} from 'ngx-popover';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        PipesModule,
        DirectivesModule,
        GridModule,
        LayoutModule,
        PopoverModule
    ],
    declarations: [
        GenericTableComponent
    ],
    exports: [
        GenericTableComponent
    ],
    providers: [
        GestionService,
        GestionOrService,
        SharedPanelService
    ]
})
export class GenericTableModule { }
